import { useState } from 'react';
import { useSignaturePad } from '../SignaturePad/useSignaturePad';
import { useSignatureGenerator } from '../SignatureGenerator/useSignatureGenerator';
import { useSignatureUploader } from '../SignatureUploader/useSignatureUploader';
import { SignatureEditorTab } from '@dealstack/frontend/shared/components/Signature/SignatureEditor/useSignatureEditor.types';

export const useSignatureEditor = () => {
	const [activeTab, setActiveTab] = useState<SignatureEditorTab>(SignatureEditorTab.DRAW);
	const pad = useSignaturePad();
	const generator = useSignatureGenerator();
	const uploader = useSignatureUploader();

	const getSignatureImageUrl = async (): Promise<string | undefined> => {
		switch (activeTab) {
			case SignatureEditorTab.DRAW:
				return pad.getSignatureImageUrl();
			case SignatureEditorTab.TYPE:
				return generator.getSignatureImageUrl();
			case SignatureEditorTab.UPLOAD:
				return uploader.imageUrl ?? undefined;
		}
	};

	const hasContent = (): boolean => {
		switch (activeTab) {
			case SignatureEditorTab.DRAW:
				return !pad.isEmpty;
			case SignatureEditorTab.TYPE:
				return !!generator.signatureText && generator.signatureText.trim().length > 0;
			case SignatureEditorTab.UPLOAD:
				return !!uploader.imageUrl;
		}
	};

	const clear = () => {
		switch (activeTab) {
			case SignatureEditorTab.DRAW:
				pad.clearSignature();
				break;
			case SignatureEditorTab.TYPE:
				generator.setSignatureText('');
				break;
			case SignatureEditorTab.UPLOAD:
				void uploader.onImageChange(null);
				break;
		}
	};

	return {
		activeTab,
		setActiveTab,
		padController: pad,
		generatorController: generator,
		uploaderController: uploader,
		getSignatureImageUrl,
		hasContent,
		clear,
	};
};
